import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isCentered", "isScrollable", "bodyOpenClassName", "titleElementId"];
import React from 'react';
import { printDeprecationWarning, useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { ModalImpl } from './ModalImpl';
import { useDeprecatedReactModalProps } from './use-deprecated-react-modal-props'; // TODO future: remove this component on next major version bump

export var BaseModal = function BaseModal(props) {
  /* eslint-disable react-hooks/rules-of-hooks */
  if (process.env.NODE_ENV !== 'production') {
    useDeprecatedComponentWarning({
      component: 'BaseModal',
      version: '8.10.0',
      migration: 'Use the <Modal> directly instead.'
    });
  }
  /* eslint-enable react-hooks/rules-of-hooks */


  var _useDeprecatedReactMo = useDeprecatedReactModalProps(props, 'BaseModal'),
      isCentered = _useDeprecatedReactMo.isCentered,
      isScrollable = _useDeprecatedReactMo.isScrollable,
      bodyOpenClassName = _useDeprecatedReactMo.bodyOpenClassName,
      titleElementId = _useDeprecatedReactMo.titleElementId,
      modalImplProps = _objectWithoutProperties(_useDeprecatedReactMo, _excluded);

  useDeprecatedClassNameStylePropsWarning('Modal', {
    className: modalImplProps.className,
    style: modalImplProps.style
  });
  return /*#__PURE__*/React.createElement(ModalImpl, _extends({
    isCentered: isCentered,
    isScrollable: isScrollable,
    bodyOpenClassName: bodyOpenClassName // spread remaining props directly onto ModalImpl

  }, modalImplProps));
}; // [DEPRECATED] only here for backwards-compatibility.  That was a passthrough to: http://reactcommunity.org/react-modal/accessibility/#app-element

BaseModal.setAppElement = function () {
  if (process.env.NODE_ENV !== 'production') {
    printDeprecationWarning({
      message: 'BaseModal.setAppElement has been deprecated and is now a NOOP. Please remove the callsites from your app. It will be removed in the next major version'
    });
  }
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  BaseModal.propTypes = _objectSpread(_objectSpread({}, ModalImpl.propTypes), {}, {
    /**
     * Applies styles to center the modal in the viewport
     */
    isCentered: PropTypes.bool,

    /**
     * Applies styles to make the modal scrollable when its height extends beyond the viewport
     */
    isScrollable: PropTypes.bool,

    /**
     * Additional ARIA attributes. This could be extended for more support.
     * @deprecated
     */
    aria: PropTypes.shape({
      labelledby: PropTypes.string
    }),

    /**
     * className to be applied to the document.body (must be a constant string).
     * See the [React Modal docs](http://reactcommunity.org/react-modal/styles/)
     * @deprecated
     */
    bodyOpenClassName: PropTypes.string,

    /**
     * Duration for modal visual animations.
     * @deprecated
     */
    closeTimeoutMS: PropTypes.number,

    /**
     * How the content container should be announced to screen readers.
     * @deprecated
     */
    contentLabel: PropTypes.string,

    /**
     * Will be run after the modal has opened.
     * @deprecated
     */
    onAfterOpen: PropTypes.func
  });
}

BaseModal.defaultProps = {
  // backwards-compatibility tweaks
  isCentered: false,
  isScrollable: true,
  // [DEPRECATED] - all props below this line should not be used.
  aria: undefined,
  bodyOpenClassName: null,
  contentLabel: undefined,
  onAfterOpen: undefined
};